import React from 'react'
import {Link} from 'react-router-dom'

import {Helmet} from 'react-helmet'

import { store } from '../../store'

import LinksFunction from './Sections/SocialLinks/LinksFunction'
import LinksSection from './Sections/SocialLinks/LinksSection'

import {ProPic, CoverImageURL} from './Sections/Images/ImageSection'

import ImageUploadFunction from './Sections/Images/ImageUploadFunction'

import Profile from './Sections/Profile/Profile'

import AboutSection from './Sections/About/AboutSection'

import {Grid, Row, Col, FormControl} from 'react-bootstrap'

const initialState = {
  page: '1'
}

class AddData extends React.Component {
  constructor(props){
    super()
    this.state = initialState;
  }
changetoTheme = () => {
    this.props.onRouteChange('template')
}
skipToCustom = () => {
    this.props.onRouteChange(store.getState().website.template)
}

render() {
  let {onClickInside, onClickOutside, onOpen, onWebsitename, onWebsiteBio, onHighlight, highlight} = this.props
  let err_msg = null
  if(this.state.error === true) {
    err_msg = <div className="save">
              <div className="save_error">
              <span
              onClick={()=>this.setState({error:false})} href="#" className="close"/>
              Error: Something went wrong
              </div>
              </div>
  }
  const pageOne = () => {
    return <Grid className={this.state.page === '1' ? "togIn" : "togOut"}>
          <Row>
          <Col lg={12} md={12} sm={12} xs={12} className="info_head">
          <h3 className="temp_headings black_color">Profile</h3>
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}>
          <div className="info_col">
          <div className="profile_pic">
          <div className="dp select" onClick={(open)=>
          {
          onOpen('propic')
          }}><i class="fa fa-camera img_edit_top_dp" aria-hidden="true"></i><img alt="dp" src={ProPic()} className="dp"/></div>
          </div>
          <div className="profile info_profile">
            <Profile onWebsitename={onWebsitename} onWebsiteBio={onWebsiteBio} onHighlight={onHighlight} highlight={highlight} />
            <div className="social_media info_social">
            <LinksFunction 
              onClickInside={onClickInside}
              onClickOutside={onClickOutside}/>        
            <LinksSection onOpen={onOpen}/>
            <span class="fa fa-plus addnew socialicon" onClick={(open)=>{onOpen('links')}}></span>
            </div>
          </div>
          </div>
          </Col>
          </Row>
          </Grid>
  }
  const pageTwo = () => {
    return <Grid className={this.state.page === '2' ? "togIn" : "togOut"}>
          <Row>
          <Col lg={12} md={12} sm={12} xs={12} className="info_head">
          <h3 className="temp_headings black_color">Background</h3>
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}>
          <div className="info_col">
          <div>
          <div className="info_label">Upload background or cover</div>
          <div className="info_cover select" onClick={
          (open,select)=>
          {
          onOpen('cover')
          }}>
          {
            store.getState().imagesPreview.length === 0
            ? null
            : <img alt="img_cover" src={CoverImageURL()} className="img_cover"/>
          }</div>
          </div>
          </div>
          </Col>
          </Row>
          </Grid>
  }
  const pageThree = () => {
    return <Grid className={this.state.page === '3' ? "togIn" : "togOut"}>
          <Row>
          <Col lg={12} md={12} sm={12} xs={12} className="info_head">
          <h3 className="temp_headings black_color">About</h3>
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}>
          <div className="info_col">
          <div className="info_about_outer">
          <div className="about info_about">
          <AboutSection/>
          </div>
          </div>
          </div>
          </Col>
          </Row>
          </Grid>
  }
      return (
        <div className="form_bg website_bg info_bg">
          <Helmet>
            <title>Insert Data</title>  
          <meta name="description" content="Start creating your profile site by picking a stunning theme" />
          <meta name="keyword" content="create profile site, free website profile, create vieww profile, create profiles fast" />
          </Helmet>
          <span href='#' className="go_back" onClick={this.changetoTheme}/>
          <span className="skip_link" onClick={this.skipToCustom}>Skip and start customization ❯</span>
          <div className="page_mark">
          <span id="page_dot_1" onClick={()=> this.setState({page: '1'})} className={this.state.page === '1' ? 'page_dot_active' : "page_dot"}>1</span>
          <span id="page_dot_2" onClick={()=> this.setState({page: '2'})} className={this.state.page === '2' ? 'page_dot_active' : "page_dot"}>2</span>
          <span id="page_dot_3" onClick={()=> this.setState({page: '3'})} className={this.state.page === '3' ? 'page_dot_active' : "page_dot"}>3</span>
          <span id="page_dot_4" onClick={this.skipToCustom} className={this.state.page === '4' ? 'page_dot_active' : "page_dot"}>4</span>
          </div>
          {this.state.page === '1' ? pageOne() : null}
          {this.state.page === '2' ? pageTwo() : null}
          {this.state.page === '3' ? pageThree() : null}

<ImageUploadFunction 
  onClickInside={onClickInside}
  onClickOutside={onClickOutside}/>
      </div>
      );
}

}
export default AddData;